/*! SafeWake ONE — country loader v2.1.0 "The Crossing" — zero dependencies.
 *  Markup snippets/country-loader.liquid · styles assets/country-loader.css · arrival head half
 *  snippets/country-arrive.liquid. Spec reports/switch-design/SPEC-2026-09-06.md.
 *  THE FULL CONTRACT (public API, the three auto-wired hooks, events, opt-outs, the arrival-key
 *  discipline, the localhost ?swcl_demo lever) is documented in the snippet's liquid comment —
 *  liquid comments are stripped at render, so it costs the visitor nothing. Read it there.
 *  In brief: window.SWCountryLoader.show({country,name,nameAr,flagSvg,accent}) → Promise after the
 *  minimum display · hide() · isActive() · version · accents · names; events swcl:show /
 *  swcl:navigate (cancelable) / swcl:hide; attributes data-min-ms / data-max-ms / data-swcl-skip.
 */
(function (w, d) {
  'use strict';
  var VERSION = '2.1.0';
  var ROOT_ID = 'sw-country-loader';
  var EXIT_MS = 260;
  var ARRIVE_KEY = 'swcl_arrive';
  var ACCENTS = { kw: '#007A3D', sa: '#006C35', ae: '#00732F', qa: '#8A1538', bh: '#CE1126', om: '#DA0000' };
  var NAMES = {
    kw: ['Kuwait', 'الكويت'], sa: ['Saudi Arabia', 'السعودية'], ae: ['UAE', 'الإمارات'],
    qa: ['Qatar', 'قطر'], bh: ['Bahrain', 'البحرين'], om: ['Oman', 'عُمان']
  };
  var SHORES = { ae: 1, kw: 1, sa: 1, qa: 1, bh: 1, om: 1 };

  var root = null, state = 'idle', pending = null, resolvePending = null;
  var tMin = null, tMax = null, tExit = null, prevFocus = null;

  function el() { return root || (root = d.getElementById(ROOT_ID)); }
  function q(sel) { var r = el(); return r ? r.querySelector(sel) : null; }
  function num(attr, dflt) { var r = el(); var v = r && parseInt(r.getAttribute(attr), 10); return v > 0 ? v : dflt; }
  function reduced() { try { return w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function store(key, val) {                                   // sessionStorage throws in some privacy modes
    try { if (val === null) w.sessionStorage.removeItem(key); else w.sessionStorage.setItem(key, val); } catch (e) {}
  }
  function emit(name, detail, cancelable) {
    var ev;
    try { ev = new CustomEvent(name, { detail: detail, bubbles: true, cancelable: !!cancelable }); }
    catch (e) { ev = d.createEvent('CustomEvent'); ev.initCustomEvent(name, true, !!cancelable, detail); }
    return (el() || d).dispatchEvent(ev);
  }

  /* Accepts an <svg> element or an SVG string; returns a sanitized clone (no scripts, handlers, external hrefs). */
  function safeSvg(input) {
    if (!input) return null;
    var node = null;
    if (typeof input === 'string') {
      try {
        var doc = new DOMParser().parseFromString(input, 'image/svg+xml');
        if (doc.getElementsByTagName('parsererror').length || !doc.documentElement || doc.documentElement.nodeName.toLowerCase() !== 'svg') return null;
        node = d.importNode(doc.documentElement, true);
      } catch (e) { return null; }
    } else if (input.nodeType === 1 && input.nodeName.toLowerCase() === 'svg') {
      node = input.cloneNode(true);
    } else { return null; }
    var all = [node].concat(Array.prototype.slice.call(node.getElementsByTagName('*')));
    for (var i = 0; i < all.length; i++) {
      var n = all[i], tag = n.nodeName.toLowerCase();
      if (tag === 'script' || tag === 'foreignobject' || tag === 'iframe' || tag === 'style' || tag === 'image') {
        if (n.parentNode) n.parentNode.removeChild(n);
        continue;
      }
      for (var j = n.attributes.length - 1; j >= 0; j--) {
        var a = n.attributes[j], an = a.name.toLowerCase(), av = String(a.value);
        if (an.indexOf('on') === 0 || ((an === 'href' || an === 'xlink:href') && av.charAt(0) !== '#') || /javascript:|data:text\/html/i.test(av)) n.removeAttribute(a.name);
      }
    }
    ['width', 'height', 'style', 'class', 'id'].forEach(function (k) { node.removeAttribute(k); });
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('focusable', 'false');
    return node;
  }

  /* No flag passed → borrow the target's flag from the switcher already in the page (code is [a-z]{2}). */
  function findFlag(code) {
    if (!code) return null;
    try {
      return d.querySelector('.sw-country-switcher__option--' + code + ' .sw-country-switcher__flag svg, ' +
        '[data-country-code="' + code + '"] .sw-country-switcher__flag svg, [data-country-code="' + code + '"] svg');
    } catch (e) { return null; }
  }
  function setFlag(flagSvg, code) {
    var chip = q('[data-swcl-flag]'); if (!chip) return;
    while (chip.firstChild) chip.removeChild(chip.firstChild);
    var svg = safeSvg(flagSvg || findFlag(code));
    if (svg) chip.appendChild(svg); else if (code) chip.appendChild(d.createTextNode(code.toUpperCase()));
  }
  function setText(name, nameAr) {
    var n = q('[data-swcl-name]'), ar = q('[data-swcl-name-ar]');
    if (n) n.textContent = name || '';
    if (ar) ar.textContent = nameAr || '';
  }
  /* The scene is the TARGET country's shore, never the departing one (spec §6).
     Two viewports share ONE <g>: the desktop <svg> frames the whole 1200-unit band, the mobile one
     frames that country's A2 crop. The crop travels ON the artwork (data-crop, written by
     reports/switch-design/shores-v2/build_shores.py) so this file holds no per-country geometry. */
  function setScene(code) {
    var cc = SHORES[code] ? code : 'ae';
    var uses = el().querySelectorAll('.swcl__shore-use, .swcl__shore-lit, .swcl__shore-use-m, .swcl__shore-lit-m');
    for (var i = 0; i < uses.length; i++) uses[i].setAttribute('href', '#swcl-shore-' + cc);
    var src = d.getElementById('swcl-shore-' + cc), m = q('.swcl__shore-svg-m');
    var crop = src && src.getAttribute('data-crop');
    if (m && crop) m.setAttribute('viewBox', crop);
    var dhow = q('.swcl__dhow-use');
    if (dhow) dhow.setAttribute('href', cc === 'om' ? '#swcl-dhowf' : '#swcl-dhow');
  }

  /* focus trap — Escape does nothing (navigation is in flight); Tab stays inside */
  function onKey(e) {
    if (state === 'idle') return;
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (e.key === 'Tab' || e.keyCode === 9) { e.preventDefault(); focusRoot(); }
  }
  function onFocusIn(e) { var r = el(); if (r && state !== 'idle' && !r.contains(e.target)) focusRoot(); }
  function focusRoot() { var r = el(); if (!r) return; try { r.focus({ preventScroll: true }); } catch (e) { r.focus(); } }

  function settle(value) {
    if (resolvePending) { var fn = resolvePending; resolvePending = null; fn(value); }
    if (tMin) { clearTimeout(tMin); tMin = null; }
  }

  function show(opts) {
    if (state === 'enter' || state === 'active') return pending;   // re-entrant
    if (state === 'exit') finishHide(true);
    var r = el();
    if (!r) return Promise.resolve(false);                          // snippet not rendered → never block the switch
    opts = opts || {};
    var code = String(opts.country || '').toLowerCase().replace(/[^a-z]/g, '').slice(0, 2);
    var known = NAMES[code];
    var name = opts.name || (known ? known[0] : code.toUpperCase());
    var nameAr = opts.nameAr != null ? opts.nameAr : (known ? known[1] : '');
    var accent = opts.accent || (r.getAttribute('data-tint') !== 'theme' ? ACCENTS[code] : '') || '';

    r.setAttribute('data-country', code);
    if (accent) r.style.setProperty('--country-accent', accent); else r.style.removeProperty('--country-accent');
    setScene(code);
    setFlag(opts.flagSvg, code);
    setText('', '');
    prevFocus = d.activeElement;
    if (SHORES[code]) store(ARRIVE_KEY, code);                      // the arriving page curtains in this country

    r.hidden = false;
    void r.offsetWidth;                                             // one flush so the opacity transition runs
    state = 'enter'; r.setAttribute('data-state', 'enter');
    w.requestAnimationFrame(function () {
      if (state !== 'enter') return;
      setText(name, nameAr);                                        // written while the live region is visible → announced
      state = 'active'; r.setAttribute('data-state', 'active');
    });
    d.addEventListener('keydown', onKey, true);
    d.addEventListener('focusin', onFocusIn, true);
    focusRoot();

    pending = new Promise(function (res) { resolvePending = res; });
    tMin = setTimeout(function () { settle(true); }, num('data-min-ms', 350));
    tMax = setTimeout(function () { hide(); }, num('data-max-ms', 4000));
    emit('swcl:show', { country: code, name: name });
    return pending;
  }

  function hide(immediate) {
    if (state === 'idle') return;
    if (tMax) { clearTimeout(tMax); tMax = null; }
    store(ARRIVE_KEY, null);           // we are still here → the switch did not happen → no curtain next load
    settle(true);
    if (immediate) return finishHide();
    if (state === 'exit') return;
    state = 'exit'; el().setAttribute('data-state', 'exit');
    tExit = setTimeout(finishHide, EXIT_MS);
  }
  function finishHide(silent) {
    if (tExit) { clearTimeout(tExit); tExit = null; }
    var r = el();
    if (r) { r.setAttribute('data-state', 'idle'); r.hidden = true; }
    d.removeEventListener('keydown', onKey, true);
    d.removeEventListener('focusin', onFocusIn, true);
    state = 'idle'; pending = null;
    if (prevFocus && prevFocus.focus && d.body.contains(prevFocus)) { try { prevFocus.focus({ preventScroll: true }); } catch (e) { prevFocus.focus(); } }
    prevFocus = null;
    if (!silent) emit('swcl:hide', {});
  }
  function isActive() { return state === 'enter' || state === 'active'; }

  var API = w.SWCountryLoader = { show: show, hide: hide, isActive: isActive, version: VERSION, accents: ACCENTS, names: NAMES };

  /* ── ARRIVAL CURTAIN ──────────────────────────────────────────────────────
     snippets/country-arrive.liquid has already painted the arriving country's sky+water over the
     page (before first paint) and cleared the session key. Lift it bottom-up once the document is
     ready and fonts have settled, capped at 450 ms. Never runs on an ordinary load: no attribute,
     no work. Reduced motion → the same lift is a 240 ms crossfade (CSS side). */
  (function arrival() {
    var h = d.documentElement;
    if (!h.getAttribute('data-swcl-arrive')) return;
    var lifted = false, ms = reduced() ? 260 : 360;
    function lift() {
      if (lifted) return; lifted = true;
      h.setAttribute('data-swcl-arrive-lift', '');
      setTimeout(function () { h.removeAttribute('data-swcl-arrive'); h.removeAttribute('data-swcl-arrive-lift'); }, ms);
    }
    function ready() {
      var f = d.fonts && d.fonts.ready;
      if (f && f.then) f.then(lift, lift); else lift();
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', ready); else ready();
    setTimeout(lift, 450);
  })();

  /* ── HOOK ─────────────────────────────────────────────────────────────── */
  function currentCountry() { var r = el(); return (r && r.getAttribute('data-current-country') || '').toLowerCase(); }
  function go(opts, href, form, field) {
    show(opts).then(function () {
      var proceed = emit('swcl:navigate', { country: opts.country, href: href, form: form }, true);
      if (!proceed) return;                                          // a listener took over
      store(ARRIVE_KEY, String(opts.country || '').toLowerCase());   // set immediately before we leave
      if (!form) return w.location.assign(href);
      if (field) {                                                   // form.submit() omits the clicked button's
        var inp = form.querySelector('input[type="hidden"][name="' + field.name + '"]');   // name/value → carry it
        if (!inp) { inp = d.createElement('input'); inp.type = 'hidden'; inp.name = field.name; form.appendChild(inp); }
        inp.value = field.value;
      }
      form.submit();
    });
  }
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target && e.target.nodeType === 1 ? e.target : e.target && e.target.parentElement;
    var a = t && t.closest ? t.closest('a.sw-country-switcher__option, a[data-swcl-country]') : null;
    if (!a || a.hasAttribute('data-swcl-skip')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^\s*javascript:/i.test(href)) return;
    if (a.target && a.target !== '_self') return;
    var code = (a.getAttribute('data-swcl-country') || a.getAttribute('data-country-code') || '').toLowerCase();
    if (!code || a.classList.contains('sw-country-switcher__option--current') || code === currentCountry()) return;
    e.preventDefault();
    var en = a.querySelector('.sw-country-switcher__name-en'), ar = a.querySelector('.sw-country-switcher__name-ar');
    go({
      country: code,
      name: a.getAttribute('data-swcl-name') || (en ? en.textContent.trim() : undefined),
      nameAr: a.getAttribute('data-swcl-name-ar') || (ar ? ar.textContent.trim() : undefined),
      flagSvg: a.querySelector('.sw-country-switcher__flag svg, [data-swcl-flag-src] svg, svg')
    }, a.href, null);
  }, false);

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || f.nodeName !== 'FORM' || f.hasAttribute('data-swcl-skip')) return;
    if (!/\/localization(\?|$)/.test(f.getAttribute('action') || '')) return;
    var sub = e.submitter || null;
    var src = (sub && sub.name === 'country_code') ? sub : f.querySelector('[name="country_code"]');
    if (!src) return;
    var code = String(src.value || '').toLowerCase(); if (!code || code === currentCountry()) return;
    e.preventDefault();
    var opt = src.options && src.selectedIndex >= 0 ? src.options[src.selectedIndex] : null;
    var en = sub && sub.querySelector('.sw-country-switcher__name-en'), ar = sub && sub.querySelector('.sw-country-switcher__name-ar');
    go({
      country: code,
      name: (sub && sub.getAttribute('data-swcl-name')) || (en && en.textContent.trim()) || (opt && opt.textContent.trim()) || undefined,
      nameAr: (sub && sub.getAttribute('data-swcl-name-ar')) || (ar && ar.textContent.trim()) || undefined,
      flagSvg: sub ? sub.querySelector('svg') : null
    }, null, f, src === sub ? { name: 'country_code', value: src.value } : null);
  }, false);

  /* back-forward cache: a page restored with the overlay up must not stay covered */
  w.addEventListener('pageshow', function (e) { if (e.persisted && state !== 'idle') hide(true); });

  /* dev demo — localhost only */
  if (/^(localhost|127\.0\.0\.1|\[::1\])$/.test(w.location.hostname)) {
    var m = /[?&]swcl_demo=([A-Za-z]{2})/.exec(w.location.search);
    if (m) { var fire = function () { show({ country: m[1] }); }; d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', fire) : fire(); }
  }
})(window, document);
